import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CaseAmendingPieStatsComponent
  from './../Components/CaseAmendingPieStatsComponent.jsx';
import { modal as modalActions } from './../actions';
import {
  getScenariosBy,
  getModalInfoByOwner,
  getModalVisibility,
  getCommonPageJobInfo
} from './../reducers';
import {
  Col,
  Row
} from 'react-bootstrap';
import { scenarios as constants, modals, jobNames } from './../helpers';

class CaseAmendingPieStatsContainer extends Component {
    static propTypes = {
      viewByImage: PropTypes.bool.isRequired,
      scenariosByImageName: PropTypes.object.isRequired,
      scenariosByJobType: PropTypes.object.isRequired,
      chartWidth: PropTypes.number.isRequired,
      onShowCaseAmendingBaselineUpdateModal: PropTypes.func.isRequired,
      modalImageName: PropTypes.string.isRequired,
      dispatcherName: PropTypes.string.isRequired
    };

    render() {
      const {
        viewByImage,
        scenariosByImageName,
        scenariosByJobType,
        chartWidth,
        dispatcherName
      } = this.props;
      let pendingCharts = [];
      let currentWidth = 0;
      const charts = [];
      const scenarios = viewByImage ?
        scenariosByImageName : scenariosByJobType;
      const keys = Object.keys(scenarios);
      for (let i = 0; i < keys.length; i++) {
        const title = keys[i];
        const jobTypesByName = viewByImage ?
          dispatcherName === jobNames.CASE_AMENDING_KPP_DISPATCHER ?
            [constants.KPPJOB_TYPE] :
            constants.getJobTypes(scenarios[title]) :
          [];
        const pieData = constants.getStateCounts(scenarios[title]);
        const panelStyle = constants.getPanelStyle(scenarios[title]);
        pendingCharts.push(
          <Col key={i} md={chartWidth}>
            <CaseAmendingPieStatsComponent
              {...this.props} {...panelStyle} pieData={pieData}
              title={title} jobTypesByName={jobTypesByName}
            />
          </Col>
        );
        currentWidth += chartWidth;
        if (currentWidth === 12 || currentWidth + chartWidth > 12 ||
          i === keys.length - 1) {
          const paddingWidth = Math.trunc((12 - currentWidth) / 2);
          let padding = null;

          if (paddingWidth > 1) {
            padding = (<Col md={paddingWidth} />);
          }

          charts.push(
            <Row key={i}>
              {padding}
              {pendingCharts}
            </Row>
          );

          pendingCharts = [];
          currentWidth = 0;
        }
      }

      return (
        <div>
          {charts}
        </div>
      );
    }
}


export const mapStateToProps = (state, ownProps) => {
  const modalInfo = getModalInfoByOwner(state, modals.owners.caseAmendingBaseline);
  const chartWidth = ownProps.chartWidth;
  const viewByImage =
    getScenariosBy(state) === constants.scenariosByImageName;
  const scenarios = ownProps.scenarios;

  const scenariosByImageName = scenarios ?
    constants.getScenariosByImageName(scenarios) : {};
  const scenariosByJobType = scenarios ?
    constants.getScenariosByJobType(scenarios) : {};
  const visible = getModalVisibility(state, modals.owners.caseAmendingBaseline);
  const modalImageName = modalInfo.imageName;
  const dispatcherName = getCommonPageJobInfo(state).jobName;

  return {
    viewByImage: viewByImage,
    scenariosByImageName: scenariosByImageName,
    scenariosByJobType: scenariosByJobType,
    chartWidth: chartWidth,
    visible: visible,
    modalImageName: modalImageName,
    dispatcherName
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onShowCaseAmendingBaselineUpdateModal: (imageName) =>
      dispatch(modalActions.showCaseAmendingBaselineUpdateModal(true, imageName))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseAmendingPieStatsContainer);


// WEBPACK FOOTER //
// src/Containers/CaseAmendingPieStatsContainer.jsx